"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APPLICANT_VISITOR_IN_CANADA_GETTING_STARTED = exports.APPLICANT_VISITOR_GETTING_STARTED = void 0;
const question_groups_1 = require("../../groups/question-groups");
const form_1 = require("../../utils/form");
exports.APPLICANT_VISITOR_GETTING_STARTED = (0, form_1.form)({
    name: "APPLICANT_VISITOR_GETTING_STARTED",
    title: "Getting started",
    content: [
        question_groups_1.QuestionGroup["APPLICANT_VISITOR_GETTING_STARTED_PART1"],
        question_groups_1.QuestionGroup["APPLICANT_VISITOR_GETTING_STARTED_PART2"],
        question_groups_1.QuestionGroup["APPLICANT_VISITOR_GETTING_STARTED_PART3"],
    ],
    id: 40,
});
exports.APPLICANT_VISITOR_IN_CANADA_GETTING_STARTED = (0, form_1.form)({
    name: "APPLICANT_VISITOR_IN_CANADA_GETTING_STARTED",
    title: "Getting started",
    content: [
        question_groups_1.QuestionGroup["APPLICANT_VISITOR_GETTING_STARTED_PART1"],
        question_groups_1.QuestionGroup["APPLICANT_VISITOR_GETTING_IN_CANADA_STARTED_PART2"],
        question_groups_1.QuestionGroup["APPLICANT_VISITOR_GETTING_STARTED_PART3"],
    ],
    id: 63,
});
